import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge only knows Tailwind's stock scales. Every font size this
 * design system adds on top of them (see `src/styles/globals.css`) has to be
 * registered here, or tailwind-merge falls through to its catch-all
 * `text-color` group and treats e.g. `text-note` as a COLOUR — at which point
 * `cn('text-white', 'text-note')` silently drops `text-white` and the element
 * renders in the inherited colour.
 *
 * Keep this list in sync with the `--text-*` tokens in `styles/globals.css`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['2xs', 'cta', 'note', 'title-sm'] }],
    },
  },
})

/**
 * Merge Tailwind class lists while resolving conflicts.
 *
 * `clsx` flattens arrays / objects / falsy values into a single string, and
 * `twMerge` deduplicates conflicting Tailwind utilities (e.g. `px-2 px-4` →
 * `px-4`). Every component runs its own defaults plus the caller's `className`
 * through this, so a caller can always override.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
